import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"
import { TaskScheduler } from "../utils/scheduler"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 15000 },
    startTime: String,
    endTime: String,
  }

  connect() {
    this.#initScheduler()
  }

  startTimeValueChanged() {
    this.#initScheduler()
  }

  endTimeValueChanged() {
    this.#initScheduler()
  }

  #initScheduler() {
    if (!this.startTimeValue && !this.endTimeValue)
      return this.scheduler?.stop()

    this.scheduler?.stop()
    this.scheduler = new TaskScheduler({
      start: this.startTimeValue,
      end: this.endTimeValue,
      interval: this.intervalValue,
      onTick: () => this.poll(),
    })
    this.scheduler.schedule()
  }

  disconnect() {
    this.scheduler?.stop()
  }

  async poll() {
    this.hasUrlValue
      ? get(this.urlValue, { responseKind: "turbo-stream" })
      : this.dispatch("refresh")
  }
}
